import { jsx as _jsx } from "react/jsx-runtime";
import { ModalConfirmForm } from 'app/components/Modal';
import { FormData } from 'app/components/Form';
import useModalResize from 'app/hooks/useModalResize';
import { optionsLogLevels } from 'app/core/constants/logLevels';
const ModalEditLog = (props) => {
    const { logValue, exponentTitle, onRequestClose, onChange } = props;
    const { modalSettings, setModalSettings } = useModalResize();
    const defaultData = !logValue
        ? {}
        : {
            message: logValue.message,
            level: logValue.level,
        };
    const onSave = (data) => {
        return onChange(data);
    };
    return (_jsx(ModalConfirmForm, { title: "Edit log", resizable: true, onResizeStop: (_, { size }) => setModalSettings((prevVal) => (Object.assign(Object.assign({}, prevVal), size))), minHeight: 450, minWidth: 420, width: modalSettings.width, height: modalSettings.height, onRequestClose: onRequestClose, exponentTitle: exponentTitle, children: _jsx(FormData, { onSave: onSave, defaultData: defaultData, properties: [
                {
                    label: 'Severity',
                    key: 'level',
                    type: 'select',
                    elementProps: {
                        isRequired: true,
                        options: optionsLogLevels,
                        fullWidth: true,
                        placeholder: 'Select a severity level',
                    },
                },
                {
                    label: 'Message',
                    key: 'message',
                    type: 'richtext',
                    elementProps: {
                        isRequired: true,
                        onInit: (editor) => editor === null || editor === void 0 ? void 0 : editor.editing.view.focus(),
                        onResizeStop: (textHeight) => setModalSettings((prevVal) => (Object.assign(Object.assign({}, prevVal), { textHeight }))),
                        defaultHeight: modalSettings.textHeight,
                    },
                },
            ] }) }));
};
export default ModalEditLog;
